import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { LatestDeviceDiagnosticDto } from '@rocksoft/appmanagement-sdk';

export type LatestDeviceDiagnosticsState = EntityState<LatestDeviceDiagnosticDto>;

export function selectId(diagnostic: LatestDeviceDiagnosticDto) {
  return diagnostic.udid ?? '';
}

export const adapter: EntityAdapter<LatestDeviceDiagnosticDto> = createEntityAdapter<LatestDeviceDiagnosticDto>({
  selectId,
});

export const initialState: LatestDeviceDiagnosticsState = adapter.getInitialState();
